export default __webpack_public_path__ + "static/media/FAVICON_48.0a106768.png";